import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../../../components/FormControls/PrimaryButton";
import WarningButton from "../../../../../../components/FormControls/WarningButton";
import request from "../../../../../../api/request";
import MessageBox from "../../../../../../components/MessageBox";
import { NotificationManager } from 'react-notifications';
import UserRulesGrid from "../../../../../../components/UserRulesGrid";

const StyledUsersSettings = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 600px;
    box-sizing: border-box;
    min-height: 495px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function UsersSettings(props) {

    const {branches, selectedBranch, refreshBranchesCallback} = props;

    const [loadedPage, setLoadedPage] = useState(false);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Usercode', type: 'String', width: 87, textAlign: 'left'},
        {id: 'Treasurer', type: 'Checkbox', width: 69, textAlign: 'center'},
        {id: 'Auditor', type: 'Checkbox', width: 64, textAlign: 'center'},
        {id: 'Viewer', type: 'Checkbox', width: 64, textAlign: 'center'},
        {id: 'Regional Finance Officer', type: 'Checkbox', width: 64, textAlign: 'center'},
        {id: 'Festival Treasurer', type: 'Checkbox', width: 64, textAlign: 'center'},
        {id: 'Branch Festival Organiser', type: 'Checkbox', width: 64, textAlign: 'center'},
        {id: 'Festival Code', type: 'String', width: 56, textAlign: 'center'}
    ]);
    const [gridData, setGridData] = useState([]);
    const [userRules, setUserRules] = useState([]);

    const onSaveChanges = async () => {
        setIsSaving(true);
        let data = {};
        data.RecordType = selectedBranch.RecordType;
        data.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        data.DivisionCode = selectedBranch.DivisionCode;
        data.usersData = gridData;

        const resp = (await request('database', 'updateBranchUserRules', [data]));
        if (resp.ok) {
            fetchUserRules();
            NotificationManager.success('Successfully updated branch user rules');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    const deleteBranch = async () => {
        setShowMessageBox(false);

        setIsDeleting(true);
        let deleteData = {};
        deleteData.RecordType = selectedBranch.RecordType;
        deleteData.RecordName = selectedBranch.RecordName;
        deleteData.BranchCommitteeCode = selectedBranch.BranchCommitteeCode;
        const resp = (await request('database', 'deleteBranch', [deleteData]));
        if (resp.ok && refreshBranchesCallback) {
            refreshBranchesCallback();
            NotificationManager.success('Branch deleted');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsDeleting(false);
    }

    const fetchUserRules = async () => {
        try {
            let userRules = [];
            let userRulesForGrid = [];

            let resp = (await request('database', 'fetchUserRules'));
            if (resp.ok) {
                resp.data.map((userRule) => {
                    userRules.push(userRule);
                    if (selectedBranch.RecordType === userRule.RecordType && selectedBranch.DivisionCode === userRule.DivisionCode && selectedBranch.BranchCommitteeCode === userRule.BranchCommitteeCode) {
                        userRulesForGrid.push({
                            'Usercode': userRule.UserName,
                            'Treasurer': userRule.IsTreasurer,
                            'Auditor': userRule.IsAuditor,
                            'Viewer': userRule.IsViewer,
                            'Regional Finance Officer': userRule.IsOfficer,
                            'Festival Treasurer': userRule.IsFestivalTreasurer,
                            'Branch Festival Organiser': userRule.IsOrganiser,
                            'Festival Code': userRule.EarmarkedFundCode
                        });
                    }
                });
                setUserRules(userRules);
                setGridData(userRulesForGrid);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch user rules: ', e);
        }
    }

    const onChangeData = (item, columnId, val) => {
        let userRules = structuredClone(gridData);
        for (let i = 0; i < userRules.length; i ++) {
            if (userRules[i]['Usercode'] === item['Usercode'] && userRules[i]['Festival Code'] === item['Festival Code']) {
                userRules[i][columnId] = val;
            }
        }
        setGridData(userRules);
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchUserRules();
            setLoadedPage(true);
        }
        if (selectedBranch) {
            let userRulesForGrid = [];

            if (userRules.length > 0) {
                userRules.map((userRule) => {
                    if (selectedBranch.RecordType === userRule.RecordType && selectedBranch.DivisionCode === userRule.DivisionCode && selectedBranch.BranchCommitteeCode === userRule.BranchCommitteeCode) {
                        userRulesForGrid.push({
                            'Usercode': userRule.UserName,
                            'Treasurer': userRule.IsTreasurer,
                            'Auditor': userRule.IsAuditor,
                            'Viewer': userRule.IsViewer,
                            'Regional Finance Officer': userRule.IsOfficer,
                            'Festival Treasurer': userRule.IsFestivalTreasurer,
                            'Branch Festival Organiser': userRule.IsOrganiser,
                            'Festival Code': userRule.EarmarkedFundCode
                        });
                    }
                });
                setGridData(userRulesForGrid);
            }
        }
    }, [selectedBranch, branches]);

    return (
        <StyledUsersSettings>
            <WhiteBoard>
                <Title>Users</Title>
                <UserRulesGrid id='branchsetting_users_grid' gridColumns={gridColumns} gridData={gridData} onChangeData={onChangeData} gridStyle={{width:530, height:380, marginTop:20}} fontSize={11}></UserRulesGrid>
            </WhiteBoard>
            <div>
                <WarningButton caption='Delete branch' isLoading={isDeleting} onClick={() => setShowMessageBox(true)} style={{width:120}}></WarningButton>
                <PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()} style={{width:150, float:'right'}}></PrimaryButton>
            </div>

            { showMessageBox && <MessageBox
                text = 'Are you sure you want to delete this branch?'
                yesText = 'Delete branch'
                noText = 'Cancel'
                isWarning = {true}
                handleClickYes = {() => {
                        deleteBranch();
                    }
                }
                handleClickNo = {() => setShowMessageBox(false)}
            />}
        </StyledUsersSettings>
    )
}

export default UsersSettings;